export default __webpack_public_path__ + "static/media/Reuters_logo.3416439b.png";